import { Form, FormActions, Modal, TextInput } from 'ui';

export type ChatGroupRenameFormValues = {
  name: string;
};

type P = {
  isPending: boolean;
  name?: string;
  onCancel: () => void;
  onFinish: (values: ChatGroupRenameFormValues) => void;
};

const ChatGroupRenameFormContent = ({ isPending, name, onCancel, onFinish }: P) => {
  const [form] = Form.useForm<ChatGroupRenameFormValues>();

  const initialValues: Partial<ChatGroupRenameFormValues> = {
    name: name ?? '',
  };

  return (
    <Form<ChatGroupRenameFormValues> form={form} initialValues={initialValues} onFinish={onFinish}>
      <TextInput
        item={{
          extra: 'Leave empty to name the chat after its participants',
          label: 'Chat name',
          name: 'name',
        }}
      />
      <Modal.HugContent.Footer>
        <FormActions
          left={{
            children: 'Reset to default',
            htmlType: 'button',
            onClick() {
              form.setFieldsValue({ name: '' });
            },
          }}
          right={{ children: 'Cancel', onClick: onCancel }}
          submit={{ children: 'Save', loading: isPending }}
        />
      </Modal.HugContent.Footer>
    </Form>
  );
};

export default ChatGroupRenameFormContent;
